export enum ErrorCodes {
    SAVED = 'Información guardada.',
    DOCK_EXISTS = 'Dock ya existe.',
    DUPLICATE_USER = 'Usuario ya existe.',
    DESCRIPCION_CODIGO_EXISTS = 'Descripción Código ya existe.',
    INVALID_DATA = 'Información inválida.',
    UNKNOWN_ERROR = 'Error desconocido.',
    DUPLICATE_DESTINATARIO = 'COD_DESTINATARIO ya existe.',
    DUPLICATE_TRANSP = 'COD_TRANSP ya existe.',
    NOT_SAVED = 'Información no guardada.',
    DUPLICATE_SOLICITANTE = 'Solicitante ya existe.',
    DUPLICATE_DESTINO_TRANSPORTISTA = 'Origen y Destino ya existe.',
    PRINTED_FAILED = 'Remito no se pudo imprimir.',
    EMAIL_SUCCESS = 'Email/s expedido.',
    EMAIL_FAILED = 'Email/s fallo al enviar.',
    CANCELAR_CON_EXITO = 'Remito cancelado correctamente.', //cancel succeeded
    CANCELAR_FALLIDO = 'Remito no puede ser cancelado en este momento, por favor intente más tarde.', //cancel failed
    INACTIVE_DOCK = 'Dock asociado al solicitante es invalido. Por favor cambie el Dock o seleccione otro solicitante',
    BLOCKED_REMITO = 'Almacen asociado tiene Remito pendiente por retornar, por favor contacte el área',
    MASTER_DATA_INACTIVE = 'Datos maestros inactivos',
    DESTINATARIO_INACTIVE = 'Destinatario es Inactivo',
    DESTINATARIO_TRANSPORTE_INACTIVE = 'Destinatario y Transporte es Inactivo',
    DESTINATARIO_CAI_INACTIVE = 'Destinatario y CAI es Inactivo',
    DESTINATARIO_DOCK_INACTIVE = 'Destinatario y Dock es Inactivo',
    DESTINATARIO_SOLICITANTE_MOTIVO_INACTIVE='Destinatario, Solicitante y Motivo es Inactivo',
    DESTINATARIO_TRANSPORTE_MOTIVO_INACTIVE='Destinatario, Transporte y Motivo es Inactivo',
    DESTINATARIO_TRANSPORTE_DOCK_INACTIVE = 'Destinatario, Transporte y Motivo es Inactivo',
    TRANSPORTE_SOLICITANTE_MOTIVO_INACTIVE='Transporte, Solicitante y Motivo es Inactivo',
    MOTIVO_TRANSPORTE_INACTIVE='Transporte y Motivo es Inactivo',
    SOLICITANTE_TRANSPORTE_INACTIVE='Solicitante y Transporte es Inactivo',
    DESTINATARIO_MOTIVO_INACTIVE='Destinatario y Motivo es Inactivo',
    DESTINATARIO_SOLICITANTE_INACTIVE='Destinatario y Solicitante es Inactivo',
    SOLICITANTE_MOTIVO_INACTIVE='Solicitante y Motivo es Inactivo',
    SOLICITANTE_CAI_INACTIVE='Solicitante y CAI es Inactivo',
    TRANSPORTE_INACTIVE = 'Transporte es Inactivo',
    TRANSPORTE_CAI_INACTIVE = 'Transporte y CAI es Inactivo',
    TRANSPORTE_DOCK_INACTIVE = 'Transporte y Dock es Inactivo',
    DOCK_CAI_INACTIVE = "Dock y CAI es Inactivo",
    CAI_INACTIVE = 'CAI es Inactivo',
    DOCK_INACTIVE = 'Dock es Inactivo',
    MOTIVO_INACTIVE = 'Motivo es Inactivo',
    ALMACEN_INACTIVE = 'Almacen es Inactivo',
    SOLICITANTE_INACTIVE = 'Solicitante es Inactivo',
    ALL_MASTER_INACTIVE = 'Destinatario, Transporte, Y CAI es Inactivo',
    ALL_MASTER__NO_CAI_INACTIVE = 'Solicitante, Almacen, Docks, Destinatario, Transporte, Motivo es Inactivo',
    INVALID_CAI = 'No hay número de CAI válido',//There is no valid CAI number available
    DUPLICATE_CAI = 'CAI ya existe.',
    OVERLAPPING_CAI = 'Ya existe un CAI diferente con rango de fechas superpuestas para esa emisión de PTO.',
    DOCK_FAILED = "Dock ya existe en New Record. Ingrese un Dock diferente.",
    MGO_REPROCESS_SUCCESS = "MGO reprocesado correctamente",
    MGO_REPROCESS_FAILED = "MGO no fue procesado. Por favor vea los errores y vuelva a procesar el archivo",
    DUPLICATE_BALANZA = "Balanza ya existe.",
    DUPLICATE_IMPRESORA = "Impresora ya existe.",
    DUPLICATE_TPRE = 'TPRE ya existe.',
    TPRE_LENGTH = 'Cód TPRE debe tener 2 dígitos.',
    VIN_NOT_FOUND = 'VIN no existe.',
    ONHOLD_RELEASE_SUCCESS = 'Liberado correctamente',
    SEND_PRINTED_REMS_SUCCESS = 'Enviado correctamente',
    OTDS_REPROCESS_SUCCESS = "Reprocessing completed successfully with {x} errors.",
    OTDS_REPROCESS_FAILED = "OTDS no fue procesado. Por favor vea los errores y vuelva a procesar el archivo",
    FILE_UPLOAD_SUCCESS = "El archivo fue procesado con éxito",
    INVALID_FILE_SIZE = "El archivo seleccionado excede el límite de tamaño.",
    INVALID_FILE_SIZE_X = "El archivo seleccionado excede {x}.",
    INVALID_FILE_EXTENSION = "El archivo seleccionado tiene una extensión de archivo no válida.",
    INVALID_FILE_EXTENSION_LIST = "El archivo seleccionado debe tener extensión {x}.",
    INVALID_FILE_MISC = "El archivo seleccionado es inválido.",
    DISPATCH_INVALID_DATA = "El archivo no pudo ser procesado por error en la información",
    FILE_UPLOAD_NO_SUCCESS = "El archivo no fue procesado.",
    FILE_UPLOAD_PROCESSED_PARTIALLY = "El archivo fue parcialmente procesado.",
    FILE_UPLOAD_ERROR_EXCEED_LIMIT = "Los errores han sido enviados por correo al administrador.",
    DISPATCH_FUTURE_DATE = "Fecha de despacho es en el futuro, por favor verifique.",
    DISPATCH_EXISTING_DATE = "Fecha de despacho se modifica por nueva fecha.",
    FILE_UPLOAD_PROCESSED_SUCCESS = "El archivo fue procesado con éxito.",
    TRANSPORTE_RELATIONSHIP_ACTIVE = "El transportista no se puede inactivar, está relacionado en la tabla de Mantenimiento de Transportistas por Origen/Destino",
    DESTINO_RELATIONSHIP_ACTIVE = "El destino no se puede inactivar, está relacionado en la tabla de Mantenimiento de Transportistas por Origen/Destino",
    ORIGEN_FAILED = "Origen no existe en el sistema para Pto Emisión. Actualice la entrada de datos maestros" +
      " utilizando la interfaz de usuario de Destinatario.",
    INVALID_FILE_UPLOAD_MISC = "El archivo no pudo ser procesado por error en la información",
    PARTIAL_FILE_PROCESSING_ERROR = "PARTIAL_FILE_PROCESSING_ERROR",
    FILE_PROCESSING_ERROR_BELOW_100_VINS = "FILE_PROCESSING_ERROR_BELOW_100_VINS",
    PARTIAL_FILE_PROCESSING_ERROR_OVER_100_VINS = "en el archivo subido hay más de 100 VINS cuyo remito no está pendiente de impresión. Se envió un email al administrador con el detalle de estos VINS.",
    OTDS_ERROR_UPDATE_MISSING_OR_REPROCESSED = "No existe tal error o ya ha sido reprocesado.",
    OTDS_ERROR_UPDATE_SUCCESS = "Error actualizado correctamente.",
    OTDS_ERROR_UNREPROCESSABLE = "No se puede reprocesar el error.",
    OTDS_ERROR_UNARCHIVABLE = "No se puede archivar el error.",
    OTDS_ARCHIVE_SUCCESS = "Archivó correctamente los registros seleccionados.",
    OTDS_ARCHIVE_FAILED =  "No se pudo archivar los registros seleccionados.",
    OTDS_ERROR_MISSING = "No existe tal error.",
    PDF_NOT_FOUND = "PDF was not found in storage for selected file.",
    LOTE_EXCEED_LIMIT = "Cantidad máxima permitida es 250 por lote.",
    VINS_EXCEED_LIMIT= "No es posible liberar más de 100 VIN a través de archivo TXT.",
    EMAIL_ERROR = "Email fallo al enviar. Remito manual no se pudo crear. Por favor inténtelo de nuevo.",
}
